/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_BodyInputs */

const en_cap_agents_body = /** @type {(inputs: Cap_Agents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A researcher, a writer, a reviewer: agents that hand work to each other, with spending limits and the points where a person signs off.`)
};

const lv_cap_agents_body = /** @type {(inputs: Cap_Agents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pētnieks, autors, recenzents: aģenti, kas nodod darbu viens otram, ar tēriņu robežām un vietām, kur apstiprina cilvēks.`)
};

/**
* | output |
* | --- |
* | "A researcher, a writer, a reviewer: agents that hand work to each other, with spending limits and the points where a person signs off." |
*
* @param {Cap_Agents_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_body = /** @type {((inputs?: Cap_Agents_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_body(inputs)
	return en_cap_agents_body(inputs)
});